<template>
  <div class="shop_list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        操作日志
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="goodslist_top">
        <div class="goodslist_title">筛选查询</div>
        <div class="goodslost_seach">
          <el-row class="goodslost_seach_row">
            
            <!-- <el-col :span="8">
              <div class="goodslost_seach_row_col">
                <div>审核状态:</div>
                 <el-select v-model="filter_status" clearable placeholder="请选择">
                  <el-option
                    v-for="item in status_list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col> -->
            <el-col :span="2">
             <div class="label">店铺</div>
            </el-col>
            <el-col :span="16">
              <el-select v-model="s_shop_name" size="small" clearable  filterable placeholder="请选择">
                <el-option
                  v-for="item in optionsArr"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8" style="text-align:center">
              <div>
                <el-button size="small" @click="seach()">搜索</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div style="margin-left:16px">
              <i class="fas fa-bars"></i>
              <span style="margin-left:6px">数据列表</span>
            </div>

            <div class="center_list_head_left_div">
              <div class="show_total">
                <el-dropdown trigger="click" @command="change_page_num">
                  <span class="el-dropdown-link show_total_span" style="c">
                    显示条数
                    <i style="font-size: 12px;" class="iconfont icon-sanjiaoxing"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="10">每页10条</el-dropdown-item>
                    <el-dropdown-item :command="15">每页15条</el-dropdown-item>
                    <el-dropdown-item :command="20">每页20条</el-dropdown-item>
                    <el-dropdown-item :command="50">每页50条</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <!-- <div class="show_total" @click="dialogFormVisible1 = true">添加用户</div> -->
            </div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table
        :header-cell-style="{'background':'#F5FAF9'}"
        v-loading="loading"
        :data="tableData"
        border
        align="center"
        style="width: 100%"
      >
       
        <el-table-column align="center" prop="check_member" label="操作员" width="100"></el-table-column>
         <el-table-column show-overflow-tooltip align="center" prop="content"  label="操作信息" width="360"></el-table-column>
        <el-table-column align="center" label="类型" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">审核通过</span>
          <span v-else-if="scope.row.status == 2">审核驳回</span>
          <span v-else-if="scope.row.status == 3">禁用</span>
          <span v-else>其他</span>
        </template>
        </el-table-column>
          <el-table-column align="center" prop="shop_name" label="店铺" width="100"></el-table-column> 
        <el-table-column align="center" prop="create_time" label="创建时间"></el-table-column>
  
      </el-table>
      <div>
        <el-pagination
          class="goodslist_bom_page"
          hide-on-single-page
          background
          layout="total , prev, pager, next"
          :page-size="limit"
          :total="total"
          @current-change="pagechange"
        ></el-pagination>
        <!-- hide-on-single-page -->
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      role: true, 
      serve: this.$store.state.serve,
      sy_name: "",
      loading: false,
      shop_name: "222",
      pass: "",
      pass1: "",
      company: "",
      product_number: "",
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      limit: 15,
      page: null,
      total: null,
      tableData: [],
      dialogFormVisible1: false,
      shopinfo: [],
      status: '1',
      return_msg: '',
      shop_id: 0,
      platform_fee: '',
      promise_fee: '',
      share_rate: '',
      filter_status: '',
      filter_shop_name: '',
      s_shop_name: '',
      optionsArr:[],
      status_list: [{
          value: '1',
          label: '审核成功'
        }, {
          value: '3',
          label: '已禁用'
        }],
        forbidden: 1
    };
  },
  created() {
    this.$store.state.topActiveId = 10;
    this.$store.state.leftTitle = "操作日志";
    this.geting();
    this.shopSearchList();
  },
  watch: {},
  methods: {
    seach() {
      this.geting();
    },
    pagechange(page) {
      this.geting(page);
    },
    change_page_num(v) {
      this.limit = v;
      this.geting();
    },
    geting(page) {
      this.loading = true;
      this.axios
        .get(this.serve + "/admin/applyLog", {
          params: {
            username: this.username,
            token: this.token,
            page: page,
            limit: this.limit,
            status: this.filter_status,
            shop_id: this.s_shop_name
          }
        })
        .then(res => {
          if(res.data.code == '403'){
            this.role = false;
          }else{   
           
            this.tableData = [];
            this.loading = false;
            if (res.data.status == "success") {
              this.page = res.data.data.page;
              this.total = res.data.data.total;
              this.tableData = res.data.data.results;
            }
          }
        });
    },
    shopSearchList() {
      this.axios
        .get(this.serve + "/admin/shopSearchList", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
     
          if (res.data.status == "success") {
            
            var arr = [];
            for(var vs of res.data.data){
               arr.push(vs);
            }
            this.optionsArr = arr;
          }
        });
    },
  }
};
</script>
<style lang="scss">
.el-form-item {
    margin-bottom: 5px;
}
.shop_list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .binaji {
    cursor: pointer;
    margin-right: 10px;
    margin-left: 10px;
    font-weight: 300;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
  }
  .binaji:hover {
    color: #0099ff;
  }
  .goodslist_bom_page {
    //  height: 80px;
    padding: 13px 0 30px 0;
    text-align: right;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .goodslist_top {
    border: 1px solid rgba(221, 221, 221, 1);
    .goodslist_title {
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      width: 1022px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #333;
      line-height: 46px;
      padding-left: 16px;
      display: flex;
      justify-content: space-between;
      padding-right: 16px;
      align-items: center;
    }
    .goodslost_seach {
      // width: 1060px;
      // line-height: 86px;
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      height: 86px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      .goodslost_seach_row {
        width: 100%;
        .goodslost_seach_row_col {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        }
      }
    }
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  //   .el-pagination {
  //     text-align: left;
  //   }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    //  display: flex;
    //  justify-content: space-between;
    .center_list_head_left {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .center_list_head_left_div {
        display: flex;
      }
      .show_total {
        font-size: 12px;
        width: 100px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        text-align: center;
        cursor: pointer;
        line-height: 30px;
        margin-right: 4px;
      }
      .show_total:hover {
        color: #3498db;
      }
      .show_total_span:hover {
        color: #3498db;
      }
    }

    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
  .useMoney{
    width: 148px;
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>